import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogData } from '../../data/blogData';  // ← Importa los datos reales
import '../stylescss/blog.css';

const BlogListPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Usar los datos reales de blogData
    setPosts(blogData);
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="blog-loading">Cargando posts...</div>;
  }

  return (
    <div className="blog-container">
      <h1 className="blog-title">Blog - IGC</h1>

      <div className="blog-grid">
        {posts.map((post) => (
          <article key={post.slug} className="blog-card">
            {post.image && (
              <img src={post.image} alt={post.title} className="blog-card-image" />
            )}
            <div className="blog-card-content">
              <h2 className="blog-card-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p className="blog-card-description">{post.description}</p>
              <Link to={`/blog/${post.slug}`} className="blog-card-link">
                Ver más →
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default BlogListPage;